import React from "react";
import { AuditLog } from "@common/types/auditLog";
import { useCategoriesById } from "@hooks/useCategoriesById";
import { AuditLogActor } from "../AuditLogActor";

interface Props {
    log: AuditLog;
}

export const TransactionLogEntityContent: React.FC<Props> = ({ log }) => {
    const authorComponent = (
        <AuditLogActor
            actorId={log.actorId}
            actorName={log.actorName}
            actorType={log.actorType}
            log={log}
        />
    );
    const newCategory = log.diff.find((d) => d.field === "categoryId");
    const newEntity = log.diff.find((d) => d.field === "entityId");
    const isBusiness = log.diff.find((d) => d.field === "isBusiness")?.after
        ?.value;
    const classificationChanged = log.diff.find(
        (d) => d.field === "classificationChanged",
    )?.after?.value;

    const categoriesById = useCategoriesById();
    const category = newCategory
        ? categoriesById[newCategory.after.value]
        : undefined;

    const categoryLabel =
        category && newCategory ? newCategory.after.valueLabel : undefined;
    const categoryUpdateMessage = categoryLabel ? (
        <>
            {" "}
            and updated category to <strong>{categoryLabel}</strong>
        </>
    ) : (
        ""
    );

    if (isBusiness) {
        return (
            <>
                <strong>{authorComponent}</strong> moved transaction to{" "}
                <strong>{newEntity?.after.valueLabel}</strong> entity
                {classificationChanged ? <> and marked it as business</> : null}
                {categoryUpdateMessage}.
            </>
        );
    } else {
        return (
            <>
                <strong>{authorComponent}</strong> marked transaction as
                personal
                {categoryUpdateMessage}.
            </>
        );
    }
};
